export default class HandleUrl {
  openUrl(event, url) {
    event.stopPropagation();
    if (url === '') return;
    window.open(url, '_blank');
  }
}
